import { render, staticRenderFns } from "./SpecialDetail.vue?vue&type=template&id=60f57cd7&scoped=true&lang=html"
import script from "./SpecialDetail.vue?vue&type=script&lang=js"
export * from "./SpecialDetail.vue?vue&type=script&lang=js"
import style0 from "./SpecialDetail.vue?vue&type=style&index=0&id=60f57cd7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f57cd7",
  null
  
)

export default component.exports